export default "__VITE_PUBLIC_ASSET__aefbabce__"